/**
 * @fileoverview カードコンポーネントを検索結果表示する用のレイアウトコンポーネント
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import LayoutContentsCardsRows from '@/components/contents/LayoutContentsCardsRows.vue'

export default defineComponent({
  name: 'LayoutSearchResultContentsCards',

  components: {
    LayoutContentsCardsRows,
  },

  props: {
    /**
     * コンテンツ情報の配列
     */
    items: {
      type: Array as PropType<ContentItem[]>,
      required: true,
    },

    /**
     * 検索文言
     * @description ハイライト表示対象
     */
    searchWord: {
      type: String,
      default: '',
    },
  },

  setup() {
    // 見出し表示オプション
    const HEADING_OPTIONS = {
      // 最大行数
      maxLine: 2,
    }

    // 画像表示オプション
    const IMAGE_OPTIONS = {
      width: {
        pc: 72,
        sp: 72,
      },
      height: {
        pc: 72,
        sp: 72,
      },
    }

    return {
      // constants
      HEADING_OPTIONS,
      IMAGE_OPTIONS,
    }
  }
})
</script>

<template>
  <LayoutContentsCardsRows
    :items="items"
    :horizontal="{ pc: true, sp: true }"
    :heading-options="HEADING_OPTIONS"
    :image-options="IMAGE_OPTIONS"
    :has-solution-link="false"
    :highlight-word="searchWord" />
</template>
